module.exports = __webpack_public_path__ + "static/media/profile_image.f0db1c5c.svg";